import { render } from "./form.vue?vue&type=template&id=df5a6cf4&scoped=true&lang=pug"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=df5a6cf4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df5a6cf4"]])

export default __exports__